export default __webpack_public_path__ + "static/media/iam_xl2.f386c0d1.png";